import { createContext, useContext } from "react";
import Searcher from "../searcher";

export const defaultSearcher = new Searcher();
export const SearcherContext = createContext(defaultSearcher);
export const useSearcher = () => useContext(SearcherContext);
